import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import type { IInteractionsModelUpdatesHandlers } from './types'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { Interact } from '@wix/interact'
import { name } from './symbols'

export const InteractionsModelUpdatesHandlers = withDependencies(
	[] as const,
	(): IModelUpdatesHandlersImplementor<IInteractionsModelUpdatesHandlers> => {
		return {
			featureName: name,
			handlers: {
				// Runs on every edit/preview switch. Entering the editor clears the preview interactions from the canvas.
				// Entering preview runs before the navigation creates the preview page's Interact instance, and clears
				// <interact-element>s that were cached while the previous preview page was torn down. Otherwise the new
				// instance binds the handlers to those detached elements instead of the live ones.
				destroyExistingInteractions: async () => {
					Interact.destroy()
				},
			},
		}
	}
)
